import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Validator from "@/pages/Validator";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-[#f0f0f0]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Validator />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid #00FF41",
            color: "#00FF41",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
}

export default App;
